<template>
  <div class="ios-logo-wrapper">
    <byted-popover
      :placement="popoverConfig.placement"
      :trigger="popoverConfig.trigger"
      :transfer="popoverConfig.transfer"
      :offset="popoverConfig.offset"
      :popper-options="popoverConfig.option"
      :disabled="disabled"
      width="auto"
    >
      <template slot="body">
        <div class="ios-logo-body">
          {{content}}
        </div>
      </template>
      <slot slot="reference" name="popover-reference">
        <div class="ios-logo ad-d-flex">
          <img :src="GET_IMG_BYTE_SRC('tos-cn-i-yvqzo4lhg5/ed92588c90e3a4a9c0d1d53e133a7124.svg~tplv-yvqzo4lhg5-image.image')" class="tips-img" />
          <span class="ios-logo-text">iOS</span>
        </div>
      </slot>
    </byted-popover>
    <slot class="ios-logo-content"/>
  </div>
</template>

<script>
export default {
  name: 'ios-logo',
  props: {
    content: {
      type: String,
      default: 'iOS专属推广广告'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    popoverConfig: {
      type: Object,
      default() {
        return {
          trigger: 'hover',
          placement: 'top-center',
          transfer: true,
          icon: 'question-circle',
          iconColor: '#999',
          iconSize: 13,
          header: '',
          body: '',
          moreUrl: '',
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.ios-logo-wrapper {
  display: inline-block;
}

.ios-logo {
  color: #338aff;
  padding: 2px 5px;
  background-color: #ebf3ff;
  border-radius: 4px;
  font-size: 12px;
  line-height: 20px;
  font-weight: 600;
  vertical-align: middle;
  margin-right: 4px;
  width: 42px;
}
.ios-logo-body {
  font-size: 12px;
  line-height: 20px;
  color: #666;
  display: flex;
  align-items: center;
  .ad-link-text-btn .byted-icon, 
  .ad-link-text-btn .bui-icon {
    top: 0px;
  }
}
.ios-logo-text {
  display: inline-block;
  line-height: 12px;
  transform: scale(.833333);
  margin-left: 3px;
  margin-top: 2px;;
}

.ios-logo-content {
  display: inline-block;
  vertical-align: middle;
}
</style>
